var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01923 18.9808V0H0V19.3846C0.0899827 19.8407 0.335829 20.2514 0.695395 20.5461C1.05496 20.8408 1.50585 21.0013 1.97077 21H24.2308V18.9808H2.01923Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28077 10.4998H6.3V16.7998H4.28077V10.4998ZM9.54692 4.03831H11.5823V16.7998H9.54692V4.03831ZM14.8292 7.26908H16.8485V16.7998H14.8292V7.26908ZM20.1115 1.61523H22.1308V16.7998H20.1115V1.61523Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.960bdc579528b9653767155bd1b615b8.svg";
export { ForwardRef as ReactComponent };